import * as Sentry from '@sentry/vue';

const initSentry = (app, router) => {
  if (process.env.NODE_ENV === 'production' && (typeof window !== 'undefined')) {
    Sentry.init({
      app,
      dsn: 'https://533a621a29ab430690ef78db89c12799@im-sentry.sportmaster.ru/79',
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        // TODO: Новая фича в Sentry для нас. Нужно разобраться для чего она и как её настраивать.
        // Sentry.replayIntegration(),
      ],
      allowUrls: [/.+\.fundayshop\.com/],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['fundayshop.com/', /^\//],
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      // replaysSessionSampleRate: 0.1,
      // replaysOnErrorSampleRate: 1.0,
    });
  }
};

export default initSentry;
